import React from "react";
import { View, ScrollView, StyleSheet, Linking } from "react-native";
import { BookOpenIcon, CaretRightIcon, CreditCardIcon, FilesIcon, QuestionIcon } from "@phosphor-icons/react";
import CustomText from "../../common/general/CustomText/CustomText";
import CustomButton from "../../common/general/CustomButton/CustomButton";

const ResourcesTab = ({ resourcesData }) => (
  <ScrollView style={{ flex: 1 }} tabIndex={0}>
    {resourcesData.officialTranscriptsUrl && (
      <View style={styles.section}>
        <FilesIcon size={20} color="#D80F7C" />
        <View style={styles.content}>
          <CustomText size="m" text="Official Transcripts" style={styles.title} />
          <CustomText size="s" text="Request or download transcripts" style={styles.subtitle} />
        </View>
        <CustomButton
          onPress={() => Linking.openURL(resourcesData.officialTranscriptsUrl)}
          text={null}
          leftIcon={<CaretRightIcon size={16} color="#667085" />}
          size="s"
          styleType="transparent"
          style={{ marginLeft: 4, padding: 0 }}
          aria-label="Official Transcripts"
          accessibilityHint="Official Transcripts"
        />
      </View>
    )}

    {resourcesData.financialInformationUrl && (
      <View style={styles.section}>
        <CreditCardIcon size={20} color="#4BA30D" />
        <View style={styles.content}>
          <CustomText size="m" text="Financial Information" style={styles.title} />
          <CustomText size="s" text="Tuition, payments, and aid" style={styles.subtitle} />
        </View>
        <CustomButton
          onPress={() => Linking.openURL(resourcesData.financialInformationUrl)}
          text={null}
          leftIcon={<CaretRightIcon size={16} color="#667085" />}
          size="s"
          styleType="transparent"
          style={{ marginLeft: 4, padding: 0 }}
          aria-label="Financial Information"
          accessibilityHint="Financial Information"
        />
      </View>
    )}

    {resourcesData.helpCenterUrl && (
      <View style={styles.section}>
        <QuestionIcon size={20} color="#007CC1" />
        <View style={styles.content}>
          <CustomText size="m" text="Help Center" style={styles.title} />
          <CustomText size="s" text="FAQ's and documentation" style={styles.subtitle} />
        </View>
        <CustomButton
          onPress={() => Linking.openURL(resourcesData.helpCenterUrl)}
          text={null}
          leftIcon={<CaretRightIcon size={16} color="#667085" />}
          size="s"
          styleType="transparent"
          style={{ marginLeft: 4, padding: 0 }}
          aria-label="Help Center"
          accessibilityHint="Help Center"
        />
      </View>
    )}

    {resourcesData.schoolResourcesUrl && (
      <View style={styles.section}>
        <BookOpenIcon size={20} color="#7839EE" />
        <View style={styles.content}>
          <CustomText size="m" text="School Resources" style={styles.title} />
          <CustomText size="s" text="Resources and Downloads" style={styles.subtitle} />
        </View>
        <CustomButton
          onPress={() => Linking.openURL(resourcesData.schoolResourcesUrl)}
          text={null}
          leftIcon={<CaretRightIcon size={16} color="#667085" />}
          size="s"
          styleType="transparent"
          style={{ marginLeft: 4, padding: 0 }}
          aria-label="School Resources"
          accessibilityHint="School Resources"
        />
      </View>
    )}
  </ScrollView>
);

const styles = StyleSheet.create({
  section: {
    marginBottom: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F9FAFB",
    borderRadius: 10,
  },
  content: {
    marginHorizontal: 8,
    flex: 1,
  },
  title: {
    fontWeight: "bold",
    color: "#101828",
  },
  subtitle: {
    fontWeight: "normal",
    color: "#475467",
  },
});

export default ResourcesTab;
